import React, { useState } from "react";
import { Modal, Button, Card } from "react-bootstrap";
import { toast } from "react-toastify";

const ApprovalModal = ({ show, onHide, selectedData, userData }) => {
    // states for data
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [rejectReason, setRejectReason] = useState("");
    const [selectedLeave, setSelectedLeave] = useState(null);

    // for reject modal
    const openRejectModal = (leave) => {
        setSelectedLeave(leave);
        setShowRejectModal(true);
    };

    // for status update
    const handleUpdateStatus = async (leave, status, reason = "") => {
        try {
            const response = await fetch(process.env.REACT_APP_BASE_URL + "/leave/updateLeaveStatus", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    applyleaveId: leave?.applyleaveId,
                    status: status,
                    approvedByempId: userData?.empId,
                    approvedByempName: `${userData?.firstName} ${userData.lastName}`,
                    rejectReason: reason
                }),
            });
            const data = await response.json();

            if (response.data) {
                toast.success(data.message || "Leave updated successfully");
            } else {
                toast.success(data.message || "Something went wrong");
            }
            setRejectReason("");
            setShowRejectModal(false);
            onHide();

        } catch (error) {
            console.error("Update error:", error);
        }
    };

    const handleRejectSubmit = () => {
        if (!rejectReason.trim()) {
            alert("Reject reason is required");
            return;
        }

        handleUpdateStatus(selectedLeave, "Rejected", rejectReason);
    };

    return (
        <>
            <Modal size="md" show={show} onHide={onHide}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Leave Approval ({selectedData?.date})
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {selectedData?.leaveData?.length > 0 ? (
                        selectedData.leaveData.map((leave, idx) => (
                            <Card key={idx} className="mb-3">
                                <Card.Body>
                                    <p><b>Employee:</b> {leave.firstName} {leave.lastName}</p>
                                    <p><b>Leave Type:</b> {leave.leaveType}</p>
                                    <p><b>Reason:</b> {leave.reason}</p>

                                    {/* <div className="d-flex gap-2 mt-2">
                                        <Button
                                            variant="success"
                                            onClick={() => handleUpdateStatus(leave, "Approved")}
                                        >
                                            Approve
                                        </Button>

                                        <Button
                                            variant="danger"
                                            onClick={() => openRejectModal(leave)}
                                        >
                                            Reject
                                        </Button>
                                    </div> */}
                                    <div className="d-flex gap-2 mt-2">
                                        {leave.status === "Approved" ? (
                                            <Button variant="success" disabled>
                                                Approved
                                            </Button>
                                        ) : leave.status === "Rejected" ? (
                                            <>
                                                <Button variant="danger" disabled>
                                                    Rejected
                                                </Button>
                                                {leave.rejectReason && (
                                                    <p style={{ color: "red", marginTop: "5px" }}>
                                                        Reason: {leave.rejectReason}
                                                    </p>
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                <Button
                                                    variant="success"
                                                    onClick={() => handleUpdateStatus(leave, "Approved")}
                                                >
                                                    Approve
                                                </Button>

                                                <Button
                                                    variant="danger"
                                                    onClick={() => openRejectModal(leave)}
                                                >
                                                    Reject
                                                </Button>
                                            </>
                                        )}
                                    </div>
                                </Card.Body>
                            </Card>
                        ))
                    ) : (
                        <p>No leave applied for this date</p>
                    )}
                </Modal.Body>
            </Modal>

            <Modal show={showRejectModal} onHide={() => setShowRejectModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Reject Leave</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        <label>Reject Reason *</label>
                        <textarea
                            className="form-control"
                            value={rejectReason}
                            onChange={(e) => setRejectReason(e.target.value)}
                            placeholder="Enter reason..."
                        />
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowRejectModal(false)}>
                        Cancel
                    </Button>

                    <Button variant="danger" onClick={handleRejectSubmit}>
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>
        </>


    );
};

export default ApprovalModal;